import React from 'react';
import HotelSearchAmadeus from '../HotelSearchAmadeus';

const Hotels: React.FC = () => {
  return <HotelSearchAmadeus />;
};

export default Hotels; 